(() => {
  'use strict';
  if (window.__printoraColourPhotoFix) return;
  window.__printoraColourPhotoFix = true;

  const normalise = (value) => String(value || '').trim().toLowerCase();

  const productJsonUrl = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) return '';
    return `${path}.js`;
  };

  const colourFromVariant = (variant, optionNames) => {
    const opts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (let i = 0; i < optionNames.length; i += 1) {
      const name = normalise(optionNames[i]);
      if ((name === 'colour' || name === 'color' || name.includes('colour') || name.includes('color'))
        && !name.includes('embroidery') && !name.includes('thread')) {
        return opts[i] || '';
      }
    }
    return '';
  };

  const imageForColour = (product, colour) => {
    const want = normalise(colour);
    if (!want || !product) return '';
    const names = product.options || [];
    for (const variant of product.variants || []) {
      if (normalise(colourFromVariant(variant, names)) !== want) continue;
      const featured = variant.featured_image || variant.featured_media || null;
      const src = featured?.src || featured?.preview_image?.src || '';
      if (src) return src.includes('?') ? `${src.split('?')[0]}?width=200` : `${src}?width=200`;
    }
    return '';
  };

  const upgrade = (product) => {
    const details = document.querySelector('.productView-details, .productView, [data-product-detail]') || document;
    const fieldsets = [...details.querySelectorAll('fieldset.product-form__input, fieldset.product-form__swatch')];
    const colourField = fieldsets.find((field) => {
      const label = normalise(field.querySelector('legend, .form__label')?.textContent || '');
      return (label.includes('colour') || label.includes('color'))
        && !label.includes('embroidery') && !label.includes('thread');
    });
    if (!colourField) return;

    colourField.querySelectorAll('input[type="radio"][value]').forEach((input) => {
      const colour = input.value;
      const src = imageForColour(product, colour);
      if (!src) return;
      const label = input.id
        ? colourField.querySelector(`label[for="${CSS.escape(input.id)}"]`)
        : input.nextElementSibling;
      if (!label) return;
      label.classList.add('pv2-colour-photo-label');
      label.style.setProperty('width', '72px', 'important');
      label.style.setProperty('height', '72px', 'important');
      label.style.setProperty('min-width', '72px', 'important');
      label.style.setProperty('min-height', '72px', 'important');
      label.style.setProperty('margin', '0 8px 8px 0', 'important');
      label.style.setProperty('padding', '0', 'important');
      label.style.setProperty('border', input.checked ? '2px solid #111' : '1px solid #d8d8d8', 'important');
      label.style.setProperty('border-radius', '0', 'important');
      label.style.setProperty('overflow', 'hidden', 'important');
      label.style.setProperty('background', '#fff', 'important');
      label.style.setProperty('display', 'inline-flex', 'important');
      label.style.setProperty('position', 'relative', 'important');
      let pattern = label.querySelector('.pattern');
      if (!pattern) {
        pattern = document.createElement('span');
        pattern.className = 'pattern';
        label.prepend(pattern);
      }
      pattern.classList.add('pv2-colour-photo');
      pattern.setAttribute('data-colour-name', colour);
      pattern.style.setProperty('background-color', '#fff', 'important');
      pattern.style.setProperty('background-image', `url(${src})`, 'important');
      pattern.style.setProperty('background-size', 'cover', 'important');
      pattern.style.setProperty('background-position', 'center', 'important');

      let expand = label.querySelector('.pv2-colour-photo-expand');
      if (!expand) {
        expand = document.createElement('span');
        expand.className = 'expand pv2-colour-photo-expand';
        const img = document.createElement('img');
        img.alt = `${colour} preview`;
        img.width = 200;
        img.height = 200;
        img.loading = 'lazy';
        img.decoding = 'async';
        expand.appendChild(img);
        label.appendChild(expand);
      }
      const img = expand.querySelector('img');
      if (img && img.getAttribute('src') !== src) img.src = src;
      expand.style.setProperty('position', 'absolute', 'important');
      expand.style.setProperty('inset', '0', 'important');
      expand.style.setProperty('margin', '0', 'important');
      expand.style.setProperty('opacity', '1', 'important');
      expand.style.setProperty('visibility', 'visible', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.style.setProperty('background', '#fff', 'important');
      pattern.style.setProperty('position', 'absolute', 'important');
      pattern.style.setProperty('inset', '0', 'important');
    });
  };

  const boot = () => {
    const url = productJsonUrl();
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((product) => { if (product) upgrade(product); })
      .catch(() => {});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    if (!/colour|color/i.test(input.name || '')) return;
    const field = input.closest('fieldset');
    field?.querySelectorAll('.pv2-colour-photo-label').forEach((label) => {
      const linked = label.getAttribute('for');
      const radio = linked ? field.querySelector(`#${CSS.escape(linked)}`) : null;
      label.style.setProperty('border', radio?.checked ? '2px solid #111' : '1px solid #d8d8d8', 'important');
    });
  });
  [200, 800, 1600].forEach((delay) => setTimeout(boot, delay));
})();
